const TRANSLATION = {
  buyModal: {
    afterFree: 'Pärast teie tasuta prooviajali',
    btn: 'Proovi tasuta',
    freeTrial: '3-päevane tasuta proov',
    monthLabel: 'kuu',
    selectLabel: 'Valige plaan',
    title: 'Tellimuse kava',
    yearLabel: 'aasta',
  },
  contact: {
    block1:
      'Kohandamiseks, küsimusteks või soovitusteks võtke meiega ühendust aadressil contact@noam.tools. Vastame kiiresti.',
    block2: 'Toetage meid hinnates meid Google Apps Extension poest ★★★★★.',
    block3: 'Aita teistele jagades seda laiendit:',
    title: 'Võta meiega ühendust',
  },
  help: {
    AquickOverviewOfNoam: 'Kiire ülevaade Noamist',
    ChatPDF: 'Chat PDF',
    ChatPDF2: 'ChatPDF',
    FavoritesManagement: 'Lemmikute haldamine',
    Fixedplugin: 'Parandatud plugin',
    Focusing: 'Fookusimine',
    Free: 'Vaba',
    FreeTrialBenefits: 'Tasuta prooviversiooni eelised',
    GoWithWikipedia: "Kasuta Wikipedia'd",
    GoWithYouTube: 'Mine koos YouTube-ga',
    HoverTranslation: 'Hover-Tõlge',
    Howtouse: 'Kuidas kasutada',
    ImageTranslation: 'Pilditõlge',
    InstantTranslation: 'Kohene tõlge',
    Membership: 'Liikmelisus',
    NoamHelp: 'Noam aitab sul tõlkida ja kokkuvõtmist teha',
    PDFparallelTranslation: 'PDF paralleelne tõlge',
    ParallelTranslation: 'Paralleelne tõlge',
    SkipAllSteps: 'Jäta kõik sammud vahele',
    Summary: 'Kokkuvõte',
    Translation: 'Tõlge',
    TryItForFree: 'Proovi tasuta',
    Video: 'Video',
    VideoSummary: 'Videoübersümmary',
    VideoTranslation: 'Video tõlge',
    WebSummary: 'Veebiülevaade',
    WordSelectionTranslation: 'Sõnade valiku tõlge',
    benefits: 'Meil on sulle ootavaid eeliseid!',
    dayFree: '3-päevane tasuta prooviajamine',
    done: 'Valmis',
    next: 'Järgmine',
    pin: 'Noami kiirjuurdepääsuks kiipa',
    planIsNotExist: 'Plani pole saadaval',
    startWiki: 'Alustame Wikimediaist!',
    startYoutube: "Alustame YouTube'ist!",
    try: 'Proovi seda',
    tryNow: 'Proovi seda nüüd!',
  },
  home: {
    PDFTranslate: {
      desc: 'Kahekordne tõlge + Vestlus PDF-ga',
      sub1: {
        desc: 'Kahekordne lugemine võimaldab võrrelda originaalteksti ja tõlget kõrvuti, parandades lugemisefektiivsust.',
        title: 'Kahekordne lugemine',
      },
      sub2: {
        desc: 'AI analüüsib ja kokkuvõtab ning võib vastata teie küsimustele PDF-sisu põhjal.',
        title: 'Chat PDF',
      },
      sub3: {
        desc: 'AI-põhine PDF-tõlge suurema täpsuse ja efektiivsuse saavutamiseks.',
        title: 'Täpsus ja tõhusus',
      },
      title: 'PDF Tõlgi',
    },
    aiAssistant: {
      desc: 'Veebitõlke tegemine intelligentseks ja mugavamaks',
      panel1: {
        desc: 'Kahekielised vastendatud tõlged võimaldavad võrrelda originaaliteksti tõlkega, et saaksite paremini mõista ja suurendada lugemisefektiivsust.',
        title: 'Kahekordne tõlge',
      },
      panel2: {
        left: {
          desc: 'Veebilehte sirvides liiguta hiirekursor over sisu, mida soovid tõlkida, et näha tõlget.',
          title: 'Kursoriteadmine',
        },
        right: {
          desc: 'Veebilehte sirvides valige tekst, mida soovite tõlkida, et näha tõlget.',
          title: 'Teksti valiku tõlge',
        },
      },
      panel3: {
        one: {
          desc: 'Tõlgi ja yhteenvetu webilehti ja videosisu igal ajal, igal pool, jätkamiseks sujuvamast kogemusest!',
          title: 'Klõpsake ja valige',
        },
        three: {
          desc: 'AI-põhine suur keelemodel tagab tõlke täpsust ja ühtsust, et parandada lugemiskogemust.',
          title: 'AI-põhine',
        },
        two: {
          desc: 'Mitmekeelsus täielikult katta, kahekielne takistuseta lugemine, üheklickne tõlge – proovi erinevust!',
          title: 'Rohkem ühtlane ja mugav',
        },
      },
      panel4: {
        tab1: {
          desc: "Sinu efektiivsuse spetsialist – kasutades ChatGPT-d tõlkab ja kokkuvõtab Noam YouTube'i videosisu, et säästa sul aega!",
          key: 'Video',
          title: 'Video tõlge ja kokkuvõte',
        },
        tab2: {
          desc: 'Klõpsake piltide tõlkimiseks veebilehte sirvides.',
          key: 'Pilt',
          title: 'Pildi tõlge',
        },
        tab3: {
          desc: 'Eeldatavasti vabaneb kiirelt võtmeinformatsiooni veebilehtedelt ja pakub kokkuvõtet, parandades teie lugemisefektiivsust.',
          key: 'Veeb',
          title: 'Veebi tõlge ja kokkuvõte',
        },
        tag1: 'Lihtne',
        tag2: 'Effektiivne',
        tag3: 'Lihtsalt mõistetav',
      },
      title: 'AI-assistent',
    },
    getStart: 'Alusta',
    getStartedForFree: 'Alusta tasuta',
    howItWork: {
      desc: 'Noam integreerib AI-mudeleid, et pakkuda kasutajatele intelligentset kogemust mitmekeelsete veebilehtede tõlkimiseks ja kokkuvõtmiseks, PDF-i ja piltide tõlkimiseks ning videote tõlkimiseks ja kokkuvõtmiseks',
      title: 'Kuidas see töötab',
    },
    lastBlock: { desc: 'Paras AI-tõlge sujuvamaks lugemiskogemuseks' },
    top: {
      desc: 'Noam on tasuta AI-veebibrauserilaiendus, mis aitab teil tõlkida ja yhteenvetada veebilehti, videoid ja PDF-sisu.\n      Liituge Noamiga ja koguge maagikat!',
      title1: 'Üks Maagia',
      title2: 'Üks Klõps',
    },
    userReviews: {
      desc: 'Viis tähte andnud arvustused Chrome-i veebipoodis',
      title: 'Kasutajaretsendid',
    },
  },
  installTips: {
    btn: 'Proovi nüüd',
    text: 'Paigalda "Noam Browser Plugin", et avada rohkem funktsioone! Veebi ristsõnastamine,\n    veebivideote kokkuvõte ja palju muud!',
  },
  locale: {
    af: 'afrikaani keel',
    am: 'amhari',
    ar: 'arabia',
    as: 'assami',
    auto: 'Automaatne tuvastamine',
    az: 'Aserbaidžaani',
    ba: 'baškir',
    bg: 'bulgaarlane',
    bn: 'bengali',
    bo: 'tiibetlase',
    bs: 'bosnia',
    ca: 'katalaani',
    cs: 'tšehhi',
    cy: 'kymri',
    da: 'taani',
    de: 'saksa',
    dsb: 'alla-sorbia',
    dv: 'divehi',
    el: 'kreeka',
    en: 'inglise keel',
    es: 'hispaania keel',
    et: 'eesti keel',
    eu: ' baski',
    fa: 'persi',
    fi: 'soome keel',
    fil: 'filippinlane',
    fj: 'fidžian',
    fr: 'Prantsuse',
    frCA: 'Prantsuse keel (Kanada)',
    ga: 'Iiri',
    gl: 'galitsia',
    gom: 'Konkani',
    gu: 'gujaarati',
    ha: 'hausa',
    he: 'heebrea keel',
    hi: 'hindi',
    hr: 'horvaadi',
    hsb: 'Ülemine sorbi keel',
    ht: 'Haiti kreoola keel',
    hu: 'ungari',
    hy: 'armeenia',
    id: 'indoneesia',
    ig: 'igbo',
    ikt: 'Inuinnaqtun',
    is: 'islannikeelne',
    it: 'itaalane',
    iu: 'inuktituti',
    iuLatn: 'Inuktituti (ladina keeles)',
    ja: 'jaapani',
    ka: 'georglane',
    kk: 'kasah',
    km: 'keomeer',
    kmr: 'kurdi (põhja)',
    kn: 'kannada',
    ko: 'korea',
    ku: 'Kürdi (kesk-)',
    ky: 'kirgiis',
    ln: 'Lingala',
    lo: 'Lao',
    lt: 'leedu',
    lug: 'Ganda',
    lv: 'lätlase',
    lzh: 'hiina keel (kirjanduslik)',
    mai: 'Maithili',
    mg: 'malagaši',
    mi: 'maorid',
    mk: 'makedoonia',
    ml: 'malajalami',
    mnCyrl: 'mongoli keel (tsüriilline)',
    mnMong: 'Mongoli (traditsiooniline)',
    mr: 'marathi',
    ms: 'malai',
    mt: 'malta',
    mww: 'Hmong Daw',
    my: 'Myanmar (burmese)',
    nb: 'norra',
    ne: 'nepali',
    nl: 'hollandi',
    noSearchLang: 'Keel ei ole toetatud',
    nso: 'Põhjas-Sesotho',
    nya: 'Nyanja',
    or: 'Odia',
    otq: 'Querétaro Otomi',
    pa: 'pandžabi',
    pl: 'poola',
    placeholder: 'Otsi',
    prs: 'Dari',
    ps: 'pasti',
    pt: 'portugeesi keel (Brasiilia)',
    ptPT: 'portugeesi keel (Portugal)',
    ro: 'romaanlane',
    ru: 'vene',
    run: 'Rundi',
    rw: 'kinjarwanda',
    sd: 'sindi',
    si: 'singaali',
    sk: 'slovaki',
    sl: 'sloveeni',
    sm: 'samoani',
    sn: 'Shona',
    so: 'Somaalia',
    sq: 'albaanlane',
    srCyrl: 'serbia (kirillitsa)',
    srLatn: 'serbia (ladina)',
    st: 'sesotho',
    sv: 'rootsi',
    sw: 'svahili',
    ta: 'tamiilane',
    te: 'telugu',
    th: 'Tai',
    ti: 'tigrinja',
    tk: 'turkmen',
    tlhLatn: 'Klingoni',
    tlhPiqd: 'klingoni (pIqaD)',
    tn: 'Setswana',
    to: 'tonga',
    tr: 'türgi',
    tt: 'tataar',
    ty: 'taiti',
    ug: 'Uiguuri',
    uk: 'Ukraina',
    ur: 'urdu',
    uz: 'Usbekki (ladina tähestik)',
    vi: 'veneetlase',
    xh: 'khoosa',
    yo: 'jorubalased',
    yua: 'yukatec maaja',
    yue: 'Kantoneesi (traditsiooniline)',
    zh: 'hiina keel',
    zhHans: 'Hiina lihtsustatud',
    zhHant: 'Hiina traditsiooniline',
    zu: 'Zulu',
  },
  login: {
    and: 'ja',
    btn: "Logi sisse Google'i abil",
    btn1: 'Logi sisse koheselt',
    desc: 'Logige sisse, et avada juurde rohkem kogemusi',
    policy: 'Privaatsuspoliitika',
    terms: 'Kasutustingimused',
    tips: 'Registreerudes nõustun',
    title: 'Tere tulemast Noami',
  },
  pageFooter: {
    follow: { facebook: 'Facebook', title: 'Jälgi', twitter: 'Twitter' },
    legal: { policy: 'Privaatsuspoliitika', terms: 'Teenuse tingimused', title: 'Juridiline' },
    product: {
      image: 'Pilditõlge',
      pdf: 'PDF tõlge',
      title: 'Tooted',
      video: 'Video tõlge ja kokkuvõte',
      web: 'Veebitõlge ja Kokkuvõte',
    },
    resources: { title: 'Ressursid' },
    tools: { title: 'Tööriistad', pdf: 'PDF tõlge' },
  },
  pageHeader: {
    contact: 'Kontakt',
    help: 'Abi',
    logout: 'Logi välja',
    logoutSucc: 'Väljalogitud.',
    pricing: 'Hinnakujundus',
    settings: 'Seaded',
    signUp: 'Logi sisse',
  },
  pdf: {
    autoDetect: 'Automaatne tuvastamine',
    cancelBtn: 'Tühista',
    cancelUpload: 'Tühista',
    chatPdf: {
      summaryError: 'Kokkuvõte ebaõnnestus, proovige hiljem uuesti',
      chatError: ' vestlus ebaõnnestus, proovige hiljem uuesti',
      Search: 'Otsi',
      cancel: 'Tühista',
      chatTitle: 'Tere tulemast Noami! Siin on sinu PDF-i kokkuvõte:',
      clear: 'Selge',
      clearContent: 'See alustab uut vestlust. Praegune vestlus ei salvestu. Olete kindel?',
      clearDialogTitle: 'Palun kinnitage',
      clearSucc: 'Kustutatud',
      copy: 'Kopeeri',
      copySucc: 'Kopeeritud',
      delete: 'Kustuta',
      deleteCancel: 'Tühista',
      deleteContent: 'See PDF-d ei saa pärast kustutamist taastada. Olete kindel?',
      deleteOk: 'Kustuta',
      deleteSuccess: 'Kustutatud',
      deleteTitle: 'Kinnita kustutamine',
      expand: 'Kollaps',
      historyTitle: 'Ajalugu',
      listError:
        'Lugemisloendi laadimine ebaõnnestus. Palun proovi hiljem uuesti või võta ühendust tugiteenusega.',
      loading: 'Laadimine...',
      noDataDesc: 'Teadaolevat ajalugu pole veel.',
      noMore: 'Rohkem sisu puudub.',
      placeholder: 'Küsi midagi selle PDF-ülesande kohta',
      summaryTitle: 'Võib-olla huvitavad sind need küsimused:',
    },
    collectionEmpty: 'Teie kogumik on tühi.',
    collectionTab: 'Märkmed',
    dataLoading: 'Laadimine...',
    dialogContent: 'Oled sa kindel, et soovid seda kustutada?',
    dialogTitle: 'Palun kinnitage',
    download: {
      both: 'Kahekõneeline',
      btn: 'Salvesta',
      cancel:
        'Selle akna sulgemine tühistab PDF-i allalaadimist. Oled kindel, et soovid tühistada?',
      desc: 'Salvesta seadmesse: Laeb tõlkeid alla piltidena; Salvesta ja trüki: Laeb tõlkeid alla originaalformaatis, koos kopeerimise toetusega.',
      download: 'Laadi alla',
      downloadMsg1: 'PDF tõlke edenemine:',
      downloadMsg2: 'Arvatav jäänud aeg:',
      downloadSucc: 'PDF on valmis! Kliki salvestamiseks.',
      downloadTip: 'PDF-i allalaadimine. Ärge sulgege seda aknat, et vältida allalaadimise vigu.',
      error: 'Salvestamine ebaõnnestus. Proovige 대신 printimist.',
      fileName: 'Failinimi:',
      fileType: 'Failitüüp:',
      loading: 'Salvestamine...',
      loading2: 'Laadimine...',
      minute: 'Minuteid...',
      msg1: 'Mõned dokumendi tõlked on originaaltekstist pikemad ja võivad allalaaditud failis kattuda. Soovime soovata lugeda veebilehel.',
      msg2: 'Tõlge ei ole veel lõpetatud. Palun laadige alla pärast tõlke lõpetamist.',
      msg3: '2. Mõned tõlked on liiga pikad. Loe veebilehel, et vältida teksti kattumist.',
      msg4: 'Tõlkimistehted on käimas. Palun proovi uuesti pärast nende lõpetamist.',
      progress: 'PDF-i tõlkimine. Edu: {{progress}}, Arvatav jäänud aeg: {{minutes}} minutit...',
      save: 'Salvesta seadmesse',
      savePrint: 'Salvesta ja prindi',
      success: 'Allalaaditud',
      trans: 'Ainult tõlge',
      transContinue: 'Jätka tõlkimist',
    },
    downloadBtn: 'Laadi alla',
    dragTipModal: {
      black: 'ruum',
      leftKey: 'vasak nupp',
      ok: 'Saan aru',
      press: 'Press',
      tips: 'libistada ja vaadata',
    },
    entry: 'PDF-d',
    fileErrMsg:
      'Faili lugemine ebaõnnestus. Palun proovige hiljem uuesti või võtke ühendust tugiteenusega.',
    fileMsg: 'Praegune faili suurus:',
    fileMsg2: 'Palun laadi üles fail, mis on väiksem kui 300MB.',
    freeBannerBtn: 'Upgrade',
    freeBannerTips: 'Tasuta PDF tõlkimiste piir reached',
    guide: {
      placeholder: 'Aseta PDF-ühendus siia',
      start: 'Alusta tõlkimist',
      text1: 'Kahekielne lugemine',
      text2:
        'Loe kahekõnkselt, et võrrelda originaaliteksti ja tõlget kõrvuti ning parandada oma tõhusust.',
      text3: ' Vestle oma PDF-ga',
      text4:
        'AI-põhine analüüs ja yhteenveto. Küsige oma PDF-ist küsimusi ja saate kohesid vastuseid.',
      text5: 'Täpne ja tõhus',
      text6: 'AI-põhine PDF-tõlge suurema täpsuse ja efektiivsuse saavutamiseks.',
      title1: 'Kahekordne tõlge',
      title2: ' Vestle oma PDF-ga',
      toast: 'Palun sisestage kehtiv online PDF-ühendus, mis lõpeb .pdf-ga',
    },
    hasTransTask: 'Tõlkimistegevus on käimas. Palun oodake.',
    hoverTrans: 'Kursoriga tõlgitavad lõigud',
    initial: 'PDF-i tõlge',
    installText: 'Teie ühekordne lahendus igapäevaste tõlgete jaoks.',
    installText2: 'Palun installi kõigepealt laiendus',
    installTips:
      'Paigalda laiendus veel rohkemate PDF-tõlgete ja sujuvamate veebilehtede tõlgete saamiseks:',
    kw: 'klambre',
    link: 'link',
    listError:
      'PDF-d ei õnnestunud laadida. Palun proovige hiljem uuesti või võtke ühendust tugiteenusega.',
    memoTotalCount: 'kokku 1 üksus',
    new: 'uus fail',
    noId: 'Faili ID ei leitud.',
    notPdf: 'Ainult PDF-failid.',
    okBtn: 'Kustuta',
    okBtn2: 'Saan aru',
    original:
      'Sa oled väga täpne ja usaldusväärne AI, mis on loodud JSON-väljundi genereerimiseks, mis vastab täpselt määratud JSON skeemile.\n\nPead järgima neid reegleid:\n1. Järgi hoolikalt JSON skeemi struktuuri.\n2. Vastuta täpselt kõigile andmetüüpidele, nõutud väljadele ja piirangutele.\n3. ÄRGE sisestage ühtegi täiendavat teksti, selgitust, markdowni ega kommentaare.\n4. Väljasta AINULT JSON objekt — mitte koodiblokeid, ega eelteksti, ega ümbritsetust.\n\nAllpool on toodud skeemi info.\n- Skeemi nimi: translate_result\n- JSON skeem:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    parallel: 'paralleelne',
    parseErrDialogContent:
      'Seda PDF-ühendust ei saa otseselt tõlkida. Palun laadige PDF alla ja üles laadige see tõlkimiseks.',
    parseErrTips: 'Faili parsimine ebaõnnestus',
    parseFileToast:
      'Faili parsimine ebaõnnestus. Palun proovige hiljem uuesti või võtke ühendust tugiteenusega.',
    pdfLoading: 'Parsimine...',
    searchPlaceholder: 'Otsi',
    selectTrans: 'Valige teksti tõlkimiseks',
    shareBtn: 'Jaga',
    shareBtnText1: 'Genereeri jagamise link',
    shareBtnText2: 'Uuenda jagatud sisu',
    shareModal: {
      cancel: 'Tühista',
      copy: 'Kopeeri',
      copySucc: 'Link kopeeritud',
      custom: 'Kohandage:',
      errMsg: 'Valitud sisu pole veel täielikult tõlgitud. Palun tõlgi enne jagamist.',
      gen: 'Jaga',
      modify: 'Redigeeri',
      notSupport: 'See keel pole praegu toetatud.',
      page: 'Lehed',
      pageNuErr: 'Palun sisestage kehtiv leheküljenumber.',
      range: 'Ulatus:',
      remain: 'jääk',
      remain1: 'Kokku hinnanguline aeg:',
      search: 'Otsi',
      settings: 'Jaga seaded:',
      shareSetting: 'Jaga sätteid',
      shareText: 'Jaga',
      shareTips: 'Jaga tõlketud PDF-i link sõpradega:',
      sourceLang: 'Alates:',
      target: 'Saaja:',
      text1: 'Jaga seaded',
      text2: 'Loo jagamise link',
      totalPage: 'kokku 1 leht',
      trans: 'Tõlgi',
      translateTips: 'Näpunäide: Kui tõlge võtab aega, saad selle akna sulgeda ja jagada hiljem.',
      translating: 'PDF-i tõlkimine...',
      update: 'Jaga lingi uuendamine',
    },
    shareMsg1: 'Jagamise link loodud.',
    shareMsg2: 'Jagatud sisu uuendatud.',
    shareMsg3:
      'Jagamise lingi genereerimine ebaõnnestus. Palun proovige hiljem uuesti või võtke ühendust tugiteenusega.',
    shareMsg4:
      'Jagatud sisu uuendamine ebaõnnestus. Palun proovige hiljem uuesti või võtke ühendust tugiteenusega.',
    shareTips: 'Teie PDF-tõlge on valmis! Jaga seda sõpradega.',
    start: 'Alusta tasuta prooviajastust',
    thumbnail: 'Sisukord',
    toast1: 'PDF-i laadimine. Palun proovi hiljem uuesti.',
    toast2: 'PDF-sisu töötletakse. Dialoogi pole praegu toetatud.',
    toast3: 'Allalaadimine. Palun proovi uuesti pärast allalaadimise lõppu.',
    toolbar: { Adjust: 'Ajusteerima', autoFit: 'Automaatne sobistamine' },
    trans: 'Tõlge',
    transSucc: 'Tõlge õnnestus!',
    unLoginToast: 'Palun logige sisse, et kasutada seda funktsiooni.',
    uploadBtn: 'Laadi üles',
    uploadErr:
      'Faili üleslaadimine ebaõnnestus. Palun proovige hiljem uuesti või võtke ühendust tugiteenusega.',
    uploadErrSignUrl:
      'Üleslaadimise URL-i hankimine ebaõnnestus. Palun proovige hiljem uuesti või võtke ühendust tugiteenusega.',
    uploadMsg1: 'Lohista fail siia.',
    uploadMsg2: 'Toetatud failitüübid: PDF  |  Maksimaalne failisuurus: 300MB',
    uploadMsg3: 'Kliki valiku tegemiseks või lohista failid siia.',
    uploading: 'Laadimine',
    uploadingMsg: 'Laadimine. Palun oodake.',
    uploadingMsg1: 'Faili üleslaadimine on käimas. Palun proovi hiljem uuesti.',
    uploadingMsg2: 'Faili konverteeritakse praegu. Palun proovi hiljem uuesti.',
    uploadingMsg3:
      'Konversiooni edenemise päring ebaõnnestus. Palun proovi hiljem uuesti või võta ühendust tugiteenusega.',
    uploadingMsg4:
      'Noam ei pääse ligi kohalikele failidele. Palun laadi manuaalselt üles PDF-d tõlkimiseks.',
    uploadingMsg5:
      'Faili URL-i hankimine ebaõnnestus. Palun proovi hiljem uuesti või võta ühendust tugiteenusega.',
    video: 'video',
    vipBannerBtn: 'Uuendamine',
    vipBannerTips: 'Olete jõudnud oma PDF-tõlke piirini selle kuu jooksul.',
    webTrans: 'Täielik vastendamine',
  },
  pricing: {
    FAQ: 'KKK',
    FQAObj: {
      a1: 'Jah, Noam pakub tasuta plaani, mida saad koheselt kasutada.',
      a2: 'Me pakume kolme liikmete plani: Pro, Pro+ ja Enterprise. Võite valida kuu- või aastapõhist maksmist. Aastapõhine arveldus pakub märkimisväärseid sääste.',
      a3: 'Kõik funktsioonid on saadaval mõlemas plaanis. Peamine erinevus on hind: aastased tellimused maksavad üldiselt vähem. Kuuslikud tellimused arvestatakse igakuine, samas kui aastased plaanid arvestatakse ühe korra aastas.',
      a4: 'Saate oma tellimuse tühistada igal ajal Kontoseadedest.',
      q1: 'Kas on vaba plaan?',
      q2: 'Milliseid hindamisplaane ja maksmisvõimalusi on saadaval?',
      q3: 'Mis on vahe kuus vs. aastas tellimise vahel?',
      q4: 'Kuidas tühistan oma tellimust?',
    },
    around: 'Ümber',
    billedMonthly: 'Arvutatakse igakuine arve',
    billedYearly: 'Arvutatakse igal aastal',
    day: 'päev',
    desc: 'Võrrelge plaanideid ja valige parim',
    detailedCompare: 'Võrrelda plaanid',
    discount: '20% alla',
    enterprise: {
      benefit1: 'Eesmärkide Klienditoe',
      benefit2: 'Mitmed kasutajad',
      benefit3: 'Koostatud lahendused',
      benefit5: 'Suunatud kontomudel',
      btn: 'Võta meiega ühendust',
      recommendText: 'Kohandatud plaanid (≥3 inimest)',
      talkToUs: 'Võta ühendust',
    },
    free: {
      benefit1: 'Kiire tõlge 100 korda päevas',
      benefit2: 'Veebilehe tõlge ja kokkuvõte',
      benefit3: '30 pilditõlget',
      benefit4: 'Video tõlge ja kokkuvõte',
      benefit5: '10 PDF-tõlget',
      benefit6: '5 000 tokenit',
      btn: 'Proovi tasuta',
      recommendText: 'Tasuta prooviversioon',
    },
    imageTranslation: 'Pildi tõlge',
    month: 'kuu',
    monthly: 'iga kuu',
    pageTitle: 'Hinnakiri',
    pdf: { chat: 'PDF Vestlussoovetused', maxPage: 'Maks. lehte PDF-is', translation: 'PDF tõlge' },
    preMonth: 'Kuu kohta',
    pro: {
      benefit1: 'Eesmärgikeeruline klientide tugi',
      benefit2: '1 000 000 tokenit kuu kohta',
      benefit3: 'Veebilehe tõlge ja kokkuvõte',
      benefit4: '200 pilditõlget',
      benefit5: 'Video tõlge ja kokkuvõte',
      benefit6: '200 PDF-tõlget',
      btn: 'Alusta',
      recommendText: 'Kõige populaarsemad',
    },
    proPlus: {
      benefit1: 'Eesindatud klienttoe',
      benefit2: '3 000 000 tokenit kuu jooksul',
      benefit3: 'Veebilehe tõlge ja kokkuvõte',
      benefit4: '500 pilditõlget',
      benefit5: 'Video tõlge ja kokkuvõte',
      benefit6: '500 PDF-tõlget',
      recommendText: 'Parim väärtus',
    },
    video: { summary: 'Videoübersümme', translation: 'Video tõlge' },
    web: {
      contrastiveTranslation: 'Kahekõneeline tõlge',
      dictionaryTranslation: 'Valikute tõlge',
      hoverTranslation: 'Hover tõlge',
      instantTranslation: 'Kiire tõlge',
      summary: 'Veebileheülesandeüleslus',
    },
    yearly: 'Igakuine',
  },
  privacy: {
    block1:
      'Noam ("Noam", "meie", "oma" või "meile") austab teie privaatsust ja on pühendunud teielt saadud või teie kohta saadud teabe kaitsmisele. See privaatsuspoliitika kirjeldab meie tavasid isikuandmete kogumiseks või kasutamiseks meie veebilehe, rakenduste ja teenuste (kokkuvõttes "Teenused") kasutamise käigus. See privaatsuspoliitika ei kehti sisu kohta, mida me käsitleme ettevõtluslike toodete klientide nimel, näiteks meie API-d. Selle andme kasutamine on reguleeritud meie klientlepinguga, mis hõlmab nende toodete juurdepääsu ja kasutamist.',
    block10:
      'Me rakendame äriliselt mõistlikke tehnilisi, halduslikke ja organisatsiooni meetmeid, et kaitsta nii online kui ka offline isikuandmeid kaotuse, väärkasutuse, autoriseerimata juurdepääsu, avaldamise, muutmise või vaenulikest tegevustest. Kuid ühtegi interneti- või e-postiülekannet ei saa tagada täielikult turvaliseks ega täpsuseks. Eriti ei pruugi olla turvalised e-kirjad, mis saadetakse meile või发自我们. Seetõttu peaksite eriti ettevaatlikud, kui otsustate, millist teavet saata meile teenuse või e-posti kaudu. Lisaks ei oleme vastutavad privaatsusmäärangute või turvameetmete rikkumisest teenuses või kolmas osapoole veebisaitide turvamäärangutes või turvameetmetes. Me säilitame teie isikuandmeid nii kaua, kui see on vajalik, et me saaksime teile teenuseid pakkuda või muude正当商业 eesmärkide nimel, näiteks vaidluste lahendamiseks, turvalisuse ja ohutusega seotud põhjustel või seaduslike kohustuste täitmiseks. Isikuandmete säilitamise kestus sõltub paljudest teguritest, näiteks teabe kogusest, olemusest, tundlikkusest, autoriseerimata kasutamise või avaldamise võimalikest riskidest, meie teabe töötlemise eesmärkidest ja muudest seaduslikult siduvatest kaalutlustest.',
    block11:
      'Me võime seda privaatsuspoliitikat aeg-ajalt uuendada. Kui me seda teeme, postitame uuendatud versiooni sellel lehel, kui kohaldatav õigus ei nõua teisiti.',
    block12:
      'Kui teil on selle privaatsuspoliitika kohta mittevastatud küsimusi või mured, palun võtke ühendust meie klienditeenindusega. E-post:',
    block2: 'Me kogume teie kohta järgmise isikliku teabe ("Isiklik teave"):',
    block3:
      'Teie poolt esitatud teave: Kui loote kasutajakontot teenuste kasutamiseks või ühendate end meiega, kogume meie isiklikku teavet järgmiste sättedega:',
    block4:
      'Isiklike andmete automaatne saamine teenuste kasutamise käigus: Kui te pääsete teenustele juurde, kasutate neid või suhtlete nendega, saame me järgmise teabe teie juurdepääsust, kasutamisest või suhtlemisest ("tehniline teave"):',
    block5: 'Võime isikuandmeid kasutada järgmistel eesmärkidel:',
    block6:
      'Ülevaade või isikustatud teave: Võime isiklikke andmeid agregatsiooni teha või isikustada, et takistada nende uuesti kasutamist isikukinnitamiseks, ning kasutada selliseid andmeid teenuste tõhususe analüüsimiseks, teenuste täiustamiseks ja uute funktsioonide lisamiseks, teadusliku uurimistöö tegemiseks ja sarnaste eesmärkide saavutamiseks. Lisaks võime analüüsida teenuste kasutajate üldist käitumist ja omadusi ning jagada agregatsiooni teavet kolmandate isikutega, avaldada sellist agregatsiooni teavet või muuta seda üldsusele kättesaadavaks. Agregatsiooni teavet võime koguda teenuste kaudu, küpsiste kaudu ja selliste teiste vahendite kaudu, mis on kirjeldatud selles privaatsuspoliitikas. Isikustatud teavet hoiame ja kasutame anonüümse või isikustatud vormis ning ei püüa sellist teavet uuesti isikustada, kui see ei ole seadusega kohustuslik.',
    block7:
      'Teatud juhtudel võime teie isikuandmeid edastada kolmanda osapoolele ilma teile täiendava teatamata, kui seadus ei nõua teisiti:',
    block8:
      'Sõltuvalt teie geograafilisest asukohast võivad Euroopa Majanduspiirkonna, Ühendkuningriigi ja kogu maailma isikud omada teatud seaduslikke õigusi oma isikuandmete osas. Näiteks võite拥有以下权利：',
    block9:
      'Teenus võib sisaldada linke teistele veebilehtedele, mida Noam ei juhinda ega kontrolli, sealhulgas sotsiaalmeedia teenuseid ("kolmandate osapoolte veebilehed"). Teie ja kolmandate osapoolte veebilehtede vahel jagatud teave reguleeritakse kolmandate osapoolte veebilehtede spetsiifiliste privaatsuspoliitikatena ja teenustingimustena, mitte sellega privaatsuspoliitikaga. Me pakume neid linke mugavuse pärast ja ei tähenda sellega nende veebilehtede heaks kiitmist ega ülevaatamist. Palun võtke kolmandate osapoolte veebilehtedega otse ühendust nende privaatsuspoliitikate ja tingimuste kohta saamiseks teavet.',
    subBlock1:
      'Kontoandmed: Kui loote meie platvormil konto, kogume me teie kontole seotud teavet, sealhulgas teie nime, kontaktandmed, kontoõigused, maksekardiandmed ja tehingute ajalugu ("Kontoandmed").',
    subBlock10: 'Teenuste pakkumine, haldamine, hooldamine ja/või analüüsimine;',
    subBlock11: 'Suhtlemine sinuga;',
    subBlock12: 'Uute toodete ja teenuste arendamine;',
    subBlock13:
      'Varguse, kriminaalse tegevuse või teenuste väärkasutamise ennetamine ning meie IT-süsteemide, arhitektuuri ja võrkude turvalisuse kaitse;',
    subBlock14: 'Ettevõtteülekanded teostamine;',
    subBlock15:
      'Õiguslikke kohustusi ja õigusmenetlusi täitmine, meie õiguste, privaatsuse, turvalisuse või vara kaitsmine, samuti meie hõlpsustatud isikute, teie või teiste kolmanda osapoole õiguste, privaatsuse, turvalisuse või vara kaitsmine.',
    subBlock16:
      'Tootjad ja teenusepakkujad: Et aidata meil täita ärioperatsiooni vajadusi ning teatud teenuseid ja funktsioone, võime anda isikuandmeid tootjatele ja teenusepakkujatele, sealhulgas hostimisteenusepakkujatele, pilveteenusepakkujatele, teistele infotehnoloogia teenusepakkujatele, e-postiühendusprogrammile ning veebianalüüsi teenusepakkujatele jne. Need partnerid pääsevad isikuandmetele ligi, töötlevad või salvestavad neid ainult meie juhise järgi, kui nad täidavad oma kohustusi meie nimel.',
    subBlock17:
      'Ettevõtte ülekanded: Kui me osaleme strateegilistes tehingutes, reorganisatsioonides, pankrottiüritustes, pankrotti ülevõtetes või teenuste üleminekus teisele pakkujale (kokkuvõttes "Tehingud"), võib teie isikuandmed ja muu info jagada tehingute partneritega ning teiste tehingute elluviimisel abistavate osapooltega due diligence protsessi käigus ning ülekandmist tehingute raames koos muude varaüksustega jätkajaettevõttesse või hõlpsustatud ettevõttesse.',
    subBlock18:
      'Õiguslikud nõuded: Võime jagada teie isikuandmeid valitsusasutustega, tööstusharude kolleegidega või muude kolmandate osapooltega, sealhulgas teie suhtlusandmeid meie teenustega, (1) kui see on seadusega nõutud või kui me usume, et selline toiming on vajalik seaduslike kohustuste täitmiseks; (2) et kaitsta ja kaitsma meie õigusi või vara; (3) kui me ühepoolt otsustame, et on rikutud meie tingimusi, säteteid või seadusi; (4) et avastada või ennetada pettust või muid ebaseaduslikke tegevusi; (5) et kaitsta meie tooteid, töötajaid või kasutajaid, või avaliku ohutuse, turvalisuse, terviklikkuse; või (vi) et kaitsma vastu seaduslikku vastutust.',
    subBlock19: 'Ava ligipääs oma isiklikele andmetele ja teabele nende töötlemise kohta.',
    subBlock2:
      'Kui kasutate meie teenuseid, kogume meie endale esitatud sissetükkide, failide üleslaadimiste või tagasiside põhjal isikuandmeid ("Sisu").',
    subBlock20: 'Taotlege oma isikuandmete kustutamist meie kirjetest.',
    subBlock21: 'Korrigeerige või värskendage oma isikuandmeid.',
    subBlock22: 'Isikliku teabe ülekandmine kolmanda osapoolele (andmete kättesaadavus).',
    subBlock23: 'Piiritage, kuidas töötleme teie isikuandmeid.',
    subBlock24:
      'Nõustumine tühistamine — kui töötlemise juriidilise alusena me eeldume teie nõustumisest, võite nõustumist igal ajal tühistada.',
    subBlock25: 'Vastusta sellele, kuidas me töötleme teie isikuandmeid.',
    subBlock26: 'Teenuste täiustamine ja teadusliku uurimistöö teostamine;',
    subBlock3:
      'Suhtlusinfo: Kui saadate meile sõnumeid, kogume teie nime, ühendustega saamiseks vajalikku teavet ja sõnumite sisu ("suhtlusinfo").',
    subBlock4:
      'Sotsiaalmeedia info: Meil on lehti sotsiaalmeedia veebisaitidel nagu Instagram, Facebook, Medium, Twitter, YouTube ja LinkedIn. Kui te interakteerite meie sotsiaalmeedia lehtedega, kogume meie isiklikku infot, mida te valite meile edastada, näiteks teie ühendusteenused ("Sotsiaalne info"). Lisaks võivad meie sotsiaalmeedia lehti majutavad ettevõtted anda meile kogumina informatsiooni ja analüüsi meie sotsiaalmeedia tegevuste kohta.',
    subBlock5:
      'Logiandmed: Teave, mida teie brauser automaatselt saadab kasutades meie teenuseid. Logiandmetesse kuulub teie Internet Protocol (IP) aadress, brauseri tüüp ja seaded, teie päringute kuupäev ja kellaaeg ning see, kuidas te veebisaitiga suhtlete.',
    subBlock6:
      'Kasutamise andmed: Võime automaatselt koguda teavet teenuse kasutamise kohta, näiteks sisu tüübidest, mida vaatate või millega suhtlete, kasutatud funktsioonidest, teostatud toimingutest, samuti teie ajavööndist, riigist, juurdepääsu kuupäevast ja ajast, kasutajaagentist ja versioonist, arvuti või mobiilse seadme tüübist ning arvutiühendusest.',
    subBlock7:
      'Seadmeinfo: See hõlmab seadme nime, operatsioonisüsteemi, seadme identifikaatorit ja kasutama olekut brauserit. Kogutud teave võib sõltuda kasutama oleva seadme tüübist ja selle seadetest.',
    subBlock8:
      'Küpsised: Me kasutame küpsiseid teenuste töökorraldamiseks, haldamiseks ja teie kasutuskogemuse parandamiseks. "Küpsis" on teavet, mida saadetakse teie külastatud veebisaiti teie brauserisse. Saate brauserit seadistada nii, et see aktsepteerib kõiki küpsiseid, keelab kõiki küpsiseid või teatab, kui küpsis pakutakse, et saaksite igakord otsustada, kas seda aktsepteerida. Kuid küpsiste keelamine võib takistada teie kasutamist või mõjutada negatiivselt veebisaiti teatud piirkondade või funktsioonide kuvamist või töökindlust. Rohkem teavet küpsiste kohta leiate aadressilt All About Cookies.',
    subBlock9:
      'Analüütika: Võime kasutada erinevaid veebianalüüsi tooteid, mis kasutavad küpsiseid, et aidata meil analüüsida, kuidas kasutajad meie teenuseid kasutavad, ning parandada teie kogemust teenuste kasutamise ajal.',
    subTitle1: 'Meie kogutud isiklikud andmed',
    subTitle2: 'Kuidas kasutame isikuandmeid',
    subTitle3: 'Isikuandmete avaldamine',
    subTitle4: 'Teie õigused',
    subTitle5: 'Lingid teistele veebilehtedele',
    subTitle6: 'Teabe turvalisus ja säilitamine',
    subTitle7: 'Privaatsuspoliitika muudatused',
    subTitle8: 'Kuidas meiega ühendust saada',
    title: 'Privaatsuspoliitika',
    updateTime: 'Uuendatud: 15. märts 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'Nõusta kõigiga',
    text: 'Ettevõtmise kogemuse parandamiseks kasutame küpsiseid sisu ja teenuste personaliseerimiseks.',
    title: 'See veebileht kasutab küpsiseid',
  },
  slogen: 'Lihtsam AI-assistent',
  stripe: {
    contact: 'Võtke meiega ühendust aadressil contact@noam.tools, kui teil on küsimusi!',
    fail: {
      btn: 'Proovi uuesti',
      text1: 'Me ei suutnud teie makset töötada läbi.',
      text2: 'Kontrolli ühendust ja proovi uuesti.',
      title: 'Makse ebaõnnestus',
    },
    succ: { btn: 'Lähme', text1: 'Tere tulemast Noami', text2: 'Alustame!', title: 'Õnne' },
  },
  terms: {
    block1: 'Aitäh, et kasutad Noami!',
    block10:
      '(a) Tasud ja arvestamine. Sa maksad kõik tasud ("Tasud") vastavalt rakenduvale hinnalehele või meie vahel kirjalikult kokkulepitud hindadele ja tingimustele. Me reserveerime õiguse korrigeerida hindamisvead või vigu isegi siis, kui oleme välja andnud arveid või saanud makset. Sa annad täielikku ja täpse arvestusinfot, sealhulgas kehtiva ja autoriseeritud maksmiseviisi. Me laeneme sinu maksmiseviisi sissetulekul perioodiliselt vastavalt kokkulepitud tingimustele, kuid võime arvestuskuupäeva mõistlikult muuta. Sa autoriseerid Noami, selle hüvangussektoreid ja kolmandate osapoolte maksmise töötajaid laenema sinu maksmiseviisist. Kui sinu makse ebaõnnestub, saadame sulle kirjaliku teatise ja võime peatada juurdepääsu teenusele kuni maksmise saabumiseni. Välja arvatud juhul, kui see leping eraldi määrab, on maksete tagasimaksmine keelatud.',
    block11:
      '(b) Maksud. Kui pole teisiti määratud, ei sisalda tasud ühtegi föderaal-, osariigi-, kohaliku ega välismaise maksu, tolli ega sarnaseid arvamisi ("Maksud"). Olete vastutavad kõigi oma ostudega seotud maksude eest, välja arvatud maksud, mis põhinevad meie puhas tulul, mille eest me teile arve esitame. Nõustute selliste maksude kiiresti maksmise ja meile seaduslikult kehtivate privaatsuspoliitikaavalduste andmise ning sellise andmehalduse jaoks vajalike nõusolekute hankimisega ning garanteerite meile, et käsitlete sellist andmeid vastavalt rakenduvale seadusele.',
    block12:
      '(c) Hindamuudatused. Me saame muuta oma hindu, teatates teile teie konto kaudu ja/või meie veebisaiti kaudu. Hinnatõus jõustub koheselt pärast postitamist. Kõik hindamuudatused rakenduvad teie konto tasudele muudatuse jõustumispäevast alates.',
    block13:
      '(d) Vaidlused ja ületatud maksmise tähtajad. Kui soovite ühtegi tasu või maksu vaidlustada, palun võtke ühendust aadressil contact@noam.tools arve kuupäevast 30 (kolmkümmend) päeva jooksul.',
    block14:
      '(e) Tasuta kasutamine. Te ei tohi luua mitmeid kontosid tasuta krediitide saamiseks. Kui me arvame, et te ei kasutata tasuta krediite ausalt, võime teile arvata standardmaksud või lõpetada teenuse juurdepääsu.',
    block15:
      '(a) Saladus. Teil võib olla juurdepääs Noami konfidentsiaalsetele andmetele. Konfidentsiaalseid andmeid võite kasutada ainult nende tingimuste alusel lubatud viisil teenuse kasutamise eesmärgil. Te ei tohi konfidentsiaalseid andmeid avaldada ükskõik millele kolmandale osapoolele ning peate kaitse tegema konfidentsiaalseid andmeid nii tõhusalt kui omaenda sarnaseid konfidentsiaalseid andmeid, vähemalt mõistliku hoolikuse tasemel. Konfidentsiaalsed andmed on avalikult kättesaamatused andmed, mida Noam on märgistanud konfidentsiaalseteks või mida tuleb asjaolude korral mõistlikult pidada konfidentsiaalseteks, sealhulgas tarkvara, spetsifikatsioonid ja muud avalikult kättesaamatused äriandmed. Konfidentsiaalseteks andmeteks ei kuulu: (1) andmed, mis on avalikult üldsusele kättesaadavad ilma teie süüeta; (2) andmed, mille teil oli omabes ilma mingita konfidentsiaalsuse kohustusteta enne nende tingimuste alusel saamist; (3) andmed, mis on teile seaduslikult avaldatud kolmandalt osapoolelt ilma mingita konfidentsiaalsuse kohustusteta; või (4) andmed, mis on teie poolt iseseisvalt töötatud välja ilma konfidentsiaalsete andmete kasutamist. Te võite konfidentsiaalseid andmeid avaldada, kui see on nõutud seaduse, kohtuniku või muu valitsusasutuse korraldusega, kuid peate Noamile esitama eelneva kirjaliku teatise mõistlikul viisil ning võimalusel tegema mõistlikke jõupingutusi avaldamise ulatuse piiramiseks, sealhulgas aitama meil vastu seista avaldamise taotlustele.',
    block16:
      '(b) Turvalisus. Peate rakendama mõistlikke ja sobivaid meetmeid teenuse juurdepääsu ja kasutamise kaitsmiseks. Kui avastate teenuse kasutamise seoses mis tahes haavatlikkusi või rikkumisi, peate kiiresti ühendust Noamiga ja esitama haavatlikkuse või rikkumise üksikasjad.',
    block17:
      '((c) Isikuandmete töötlemine. Kui kasutate teenust isikuandmete töötlemiseks, peate pakkuma seaduslikult piisavaid privaatsuspoliitikaavaldusi ja saama töötlemiseks vajalikud nõusolekud, ning garanteerite meile, et käsitlete selliseid andmeid vastavalt kohaldatavatele seadustele.',
    block18:
      '(a) Lõpetamine; peatamine. Nendes tingimustes kehtivad alates teie esimesest teenuse kasutamisest ja kehtivad kuni nende lõpetamiseni. Saate need tingimused lõpetada igal ajal ja igas põhjusel lõpetades teenuse ja sisu kasutamise. Me saame need tingimused lõpetada ette teatades igas põhjusel. Me saame need tingimused koheselt lõpetada teie teavitamisega, kui te oluliselt rikutakse 2. peatükki (Kasutustingimused), 5. peatükki (Salajasus, turvalisus ja andmekaitse), 8. peatükki (Võitluste lahendamine) või 9. peatükki (Üldised säted), või kui meie suhe mis tahes kolmanda osapoole tehnoloogia pakkujaga, mille üle meil ei ole kontrolli, muutub, või seoses seaduste või valitsuslike taotlustega. Me saame peatada teie juurdepääsu teenusele, kui te ei järgi neid tingimusi, või kui teie kasutamine kujutab endast turvalisusriskit meie või mis tahes kolmanda osapoole jaoks, või kui me oletame, et teie kasutamine on pettuslik või võib avaldada meid või mis tahes kolmanda osapoole vastutuse alla.',
    block19:
      '(b) Lõpetamise mõjud. Lõpetamise korral lõpetate teenuse kasutamise ja tagastate või hävitate koheselt kõik konfidentsiaalsed andmed meie juhistele vastavalt. Nende tingimuste sätete, mis loomult peaksid säilima lõpetamise või aegumise järel, sealhulgas kuid mitte ainult peatükid 3 ja 5–9, säilivad.',
    block2:
      'Nadala kasutustingimused kehtivad Noami teenuste kasutamise kohta, sealhulgas meie rakendusprogrammeerimisteenuste liidesed, tarkvara, tööriistad, arendajate teenused, andmed, dokumentatsioon ja veebileht (kokku nimetatakse "Teenusteks"). Teenuste kasutamisel nõustute nendega tingimustega järgimist. Meie privaatsuspoliitika selgitab, kuidas me kogume ja kasutame isikuandmeid.',
    block20:
      '(a) Indemnisatsioon. Te kaitsege, tagate hüvitist ning hoidke meid, meie filiaale ja meie töötajaid kahjumi eest kõigi nõudmiste, kahjumite ja kulude (sealhulgas advokaatide tasud) eest, mis tulenevad teie teenuse kasutamisest või on sellega seotud, sealhulgas teie sisu, teie teenusega seotud toodete või teenuste kasutamise ning teie nende tingimuste või kohaldatava seaduse rikkumise tõttu.',
    block21:
      '(b) Vabandused. Teenus tarnitakse "nagu on". Seadusega lubatud piirides ei anna meie ega meie hõlpsustajad ega litsentsidendid ühtegi mingeid esindusi ega garanteedeid teenuse kohta ega anna ühtegi garantiid, sealhulgas, kuid mitte ainult kaubanduslikkuse, sobilikkuse konkreetsele eesmärgile, rahuldava kvaliteedi, puudumise rikkumiste ja rahulikku kasutamist ning ühtegi garantiid, mis tuleneb käitumise või kaubandusliku kasutamise käigus. Me ei garanteeri, et teenus oleks peatamatu, täpne või vigaeta, ega et sisu oleks turvaline, ei kadunud ega muudetud.',
    block22:
      '(c) Vastutuse piiramine. Ei meie, ega meie sidusrühmad ega litsentdajad pole vastuudega mis tahes indirektse, juhusliku, spetsiaalse, järeltulemuse põhjalise või karistusliku kahju eest, sealhulgas kasumite kadu, maine kadu, kasutamise kadu, andmete kadu või muu ainevaba kaotuse eest, isegi kui meile on teatatud sellise kahju võimalusest. Nende tingimuste alusel ei ületa meie koguvastutus teie teenusele viimase 12 (kaksteist) kuu jooksul makstud tasusid ega 100 USA dollarit (100 USD), sõltumata sellest, mis on suurem. Selles osas toodud piirangud kehtivad kohaldatava seaduse lubatud maksimaalse ulatuses.',
    block23:
      'Nõuded ja teenuste kasutamine on reguleeritud Ameerika Ühendriikide seadustega, välja arvatud Ameerika Ühendriikide seaduspärimissuhete sätete kohaldamine. Rakenduse kasutamine võib olla ka allutatud muude kohalike, osariigi, riiklikke või rahvusvahelisi seadusi. Kõik nendele Nõuetele relateeruvad juriidilised üritused või protsessid toimumad ainult Ameerika Ühendriikide kohtutes, ning nõustute selliste kohtute isikliku jurisdiktsiooni allumisele.',
    block24:
      'Osapoolte suhe. Noam ja te olete sõltumatud töövõtjad ning ükski osapool ei ole volitatud esindama või siduma teist osapoolt ega võtma enda kanda kohustusi teise osapoole eest ilma teise osapoole eelneva kirjaliku nõusolekuta.',
    block25:
      '(b) Brändi kasutamine. Te ei tohi kasutada Noami või selle ükski sidusrühma nimi, logo ega kaubamärke ilma meie eelne ilma kirjalikuta nõusolekuta.',
    block26:
      'Kui mingit neist tingimustest või nende osast tühistatakse, lepitakse see ebaõiguslikuks või ei saa jõustada, jäävad ülejäänud säted täielikult jõusse ja kehtivusele.',
    block3:
      'Kui olete alla 18-aastane, peate teenuse kasutamiseks saama vanemate või seaduslike hooldajate lubaduse. Kui kasutate teenust teise inimese või ettevõtte nimel, peate olema volitatud nende nimel nende tingimuste vastu võtma. Konto registreerimiseks peate esitama täpse ja täieliku teabe. Te ei tohi oma juurdepääsuandmeid ega kontot anda kedagi teie organisatsiooni väljaspoolt, ning olete vastutavad kõigi tegevuste eest, mis toimuvad kasutades teie andmeid.',
    block4:
      '(a) Teenuse kasutamine. Võite juurdepääseda teenusele nende tingimuste alusel, ning me anname teil mittuuringuvõtmeline õigus kasutada teenust. Teenust kasutades järgite neid tingimusi ja kõiki kohaldatavaid seadusi. Meie ja meie filiaalidel on kõik õigused, omandiõigus ja huvid teenuses.',
    block5:
      '(b) Tagasiside. Meil on teretulnud tagasiside, kommentaarid, ideed, soovet ja täiustusi. Kui te esitate sellist sisu, võime seda kasutada ilma ükski piiranguteta ja ilma teile kompensatsiooni maksmata.',
    block6:
      '(c) Piirangud. Te ei tohi: (1) kasutada teenust viisil, mis rikub, vääristab või ületab kedagi teise õigusi; (2) teostada teenuse mudelite, algoritmide ja süsteemide lähtekoodi või aluskomponentide avastamiseks vastupidist inseneringut, dekompileerimist, lahtikapitalistamist, tõlket või muud katsetusi (kui selliseid piiranguid ei keela kohaldatav õigus); (3) kasutada teenuse väljundit Noamiga konkurreerivate mudelite arendamiseks; (4) ekstraheerida teenusest andmeid või väljundit kasutades mis tahes automatiseeritud või programmeeritud meetodeid, kui neid ei ole lubatud API kaudu, sealhulgas skrapingut, veebi korjamist või veebiandmete ekstraheerimist; (5) esitada teenuse väljundit kui kunstlikult genereeritud, kui see ei ole nii, või muul viisil rikkuda meie kasutuspoliitikat; (6) osta, müüa või ülekandmise API-võtmeid ilma meie eelneva nõusolekuta; või (7) esitada meile 13-aastaste laste või kohaldatava digitaalse nõusoleku vanuse isiku isiklikke andmeid. Te järgite meie dokumentatsioonis toodud kõiki sageduspiire ja muid nõudeid.',
    block7:
      '(d) Kolmasosad teenused. Kõik teenusega seotud kolmasosaste tarkvara, teenused või muud tooted reguleeritakse nende enda tingimustega ning me ei vastuta kolmasosaste toodete eest.',
    block8:
      '(a) Teie sisu. Te võite pakkuda teenusele sisendit ("Sisend") ja saada vastavalt sisendile genereeritud ja tagastatud väljundit ("Väljund") (kokku nimetatakse "Sisu"). Osapoolte vahel ning kohaldatava seaduse lubades piirides omate teie kõigi sisendite omandiõigust. Noam võib kasutada sisu teenuse pakkumiseks ja hooldamiseks, kohaldatava seaduse järgimiseks ning meie poliitikate jõustamiseks. Olete vastutavad sisu eest, sealhulgas tagades, et see ei riku ühtegi kohaldatavat seadust ega neid tingimusi.',
    block9:
      '(b) Täpsus. Tehisintellekt ja masinõpe on kiiresti arenevaid teadusuuringute valdkondi. Me püüame pidevalt parandada oma teenust, et see oleks täpsem, usaldusväärsem, turvalisem ja kasulik. Arvestades masinõppe tõenäosuslikku olemust võib teenuse kasutamine teatud juhtudel põhjustada ebatäpseid väljundeid, mis ei kajasta täpselt päris inimesi, kohtasid ega tõde. Peate hindama igasuguse väljundi täpsust vastavalt oma kasutuskorrale, sealhulgas teostades käsitsi ülevaatusi.',
    subTitle1: 'Registreerimine ja juurdepääs',
    subTitle10: 'Eraldatavus',
    subTitle2: 'Kasutustingimused',
    subTitle3: 'Sisu',
    subTitle4: 'Maksud ja maksmine',
    subTitle5: 'Konfidentsiaalsus, Turvalisus ja Andmekaitse',
    subTitle6: 'Aeg ja Lõpetamine',
    subTitle7: 'Kohustatus hüvitada; Keeldumised; Kohustuse piiramine',
    subTitle8: 'Reguleeriv õigus ja jurisdiktsioon',
    subTitle9: 'Üldised tingimused',
    title: 'Teenuse tingimused',
    updateTime: 'Uuendatud: 15. märts 2024',
  },
  trialModal: {
    btn: 'Alusta koheselt (ainult $0.99)',
    chat: 'ChatPDF',
    desc1: 'Prooviperioodi lõppedes teie arvele lisatakse aastane tasu 180 dollarit',
    desc2: 'Tühistada igal ajal',
    focus: 'Fookus',
    hover: 'Hover tõlge',
    image: 'Pilditõlge',
    installBtn: 'Installi koheselt, et saada oma kingitus',
    memo: 'Lemmikute haldamine',
    pdf: 'PDF paralleelne tõlge',
    realtime: 'Kiire tõlge',
    select: 'Sõnavali valiku tõlge',
    title: 'Tervituskink',
    trialText: '7-päevane prooviajamine',
    video: 'Video tõlge',
    videoSummary: 'Videoübersütlus',
    web: 'Parallelne tõlge',
    webSummary: 'Veebi kokkuvõte',
  },
  upgradeModal: {
    btn: 'Uuenda nüüd',
    chat: { free: "Olete jõudnud ChatPDF'i piiri", pro: "Olete jõudnud ChatPDF'i kuu piirini" },
    contactStr:
      'Palun oodake järgmist lähtestamist või võtke meiega ühendust aadressil contact@noam.tools.',
    limitAlertStr: 'Olete jõudnud tasuta plaani piirini. Uuritage taset üles, et jätkata.',
    more: 'Vaata plaanid',
    pageLimit: { free: 'Olete jõudnud PDF-lehtede limiiti' },
    title: 'Meeldetuletus',
    upgradeAlertStr: 'Olete jõudnud tasuta plaani piirini. Uurake üles, et jätkata.',
    upload: {
      free: 'Olete jõudnud oma PDF-tõlke piirini',
      pro: 'Olete jõudnud oma PDF-tõlke piirini sel kuul',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'Liitu kohe',
      label: 'Uute kasutajate eelised:',
      remain: 'Jääb alles ainult 30',
      text: 'Ainult 100 koht on saadaval! Võta oma kohe!',
    },
  },
  aiPdfTranslator: {
    title: 'Vaba AI PDF-tõlkija: Tõlgi PDF-d võrdlusega mis tahes keeltes',
    desc: 'Lihtsalt tõlgi PDF-faile AI abil mis tahes keelde. Võrrelge originaali- ja tõlketeksti kõrvuti, kiiresti ja tasuta.',
    keywords: 'GPT-4、AI Assistent、Tõlge、Kokkuvõte、Fookus、ChatPDF、Märkus、effektiivsus',
    sourceToTarget: {
      title: 'Vaba PDF tõlkimisvahend: tõlgi {{source}} {{target}}ks tasuta',
      desc: 'Tõlgi oma PDF-faile mis tahes allikakeelest soovitud keelde tasuta. Kiire, täpne ja turvaline PDF-tõlge, mis töötab täiustatud AI-ga.',
    },
    headerIntroduce: {
      title: 'Noam: rohkem kui lihtsalt veebitõlge',
      introduce1: {
        title: 'Noam · PDF-loetaja',
        desc: '✨Kõrvalekstiline tõlge + AI K&V. Kiiresti ja täpselt tõlgi PDF-d oma sihtkeelde. Vabalt esita küsimusi sisu kohta, et saada sügavamaks arusaamaks oma PDF-failidest.',
      },
      introduce2: {
        title: 'Noam · Kõrval-kõrval tõlkefail',
        desc: '👏Lahendage kõik oma veebilehe tõlkimisvajadused:',
        detail1: { title: 'Veebilehe tõlge:', desc: 'Kõrval-kõrval kakskeelne vaade' },
        detail2: { title: 'Sõna tõlge:', desc: 'Üheklikkeline kiir tõlge.' },
        detail3: { title: 'Kiire tõlge:', desc: 'Tõlgi sõnu või lauseid koheselt.' },
        detail4: { title: 'Pildi tõlge:', desc: 'Asenda pildid tõlgitudega.' },
        detail5: {
          title: 'Video tõlge:',
          desc: 'Kahekielised subtitraadid parema vaatamise jaoks.',
        },
        footer: 'Koguge rohkem AI-põhiseid lugemisomadusi intelligentsemaks tõlkimiseks!',
      },
    },
    subtitle: 'PDF-i tõlge veebis tasuta',
    introduce: {
      module1: {
        detail1: {
          title: 'Reaalajas kõrvuti PDF-tõlge',
          desc1: 'Kuva koheselt originaal- ja tõlketeksti sünkroonitud kõrvuti paigutuses',
          desc2: 'Lihtsalt võrreldage mõlemaid versioone sünkroonitud kerimisega',
          desc3: 'Säilitage identne vorming ühtlase lugemiskogemuse tagamiseks',
        },
        detail2: {
          title: 'Täpse sisu sissemääramine ja kontrollimine',
          desc1:
            'Läbimõeldud sünkroonimine allikateteksti ja tõlketeksti vahel lihtsa kontrollimise jaoks',
          desc2: 'Iga sisusegment klappib mõlema versiooni vahel täpselt',
          desc3: 'Kiiresti tuvasta ja lahenda tõlkeerinevusi usaldusväärsete tulemuste saamiseks',
        },
      },
      module2: {
        detail1: {
          title: 'Mitmeid täpsete tõlgete jaoks täiustatud AI mudeleid',
          desc1: 'Valige juhtivate AI mudelite hulgast oma tõlkerequiremendidest vastava',
          desc2: 'Tagage optimaalsed tulemused erinevate dokumenditüüpide ja tööstusharude jaoks',
          desc3: 'Paindlikud mudelioptioonid pakuvad igale stsenaariumile kohandatud lahendusi',
        },
        detail2: {
          title: 'Täiustatud AI-tõlge kõigile sisu tüüpidele',
          desc1: 'Meie tugev AI-mudel tagab kõrget täpsust ja looduslikku keeleymmärtmist',
          desc2: 'Käsitseb tehnilisi, akadeemilisi ja loomingulisi dokumente lihtsalt',
          desc3: 'Annab usaldusväärseid tulemusi kõigi teie tõlkimisvajaduste jaoks',
          desc4:
            'Intelligentset kohandamist erinevate sisu tüüpidele optimaalse jõudluse saavutamiseks',
        },
      },
      module3: {
        detail1: {
          title: 'Intelligentsed Dokumendivõtted',
          desc1: 'Lihtsalt vestle oma PDF- ja esitlusfailidega kasutades arenenud AI-d',
          desc2: 'Küsi koheselt küsimusi dokumendi sisu kohta ja saad täpseid vastuseid',
          desc3: 'Kiiresti genereeri lühikesed kokkuvõtted pikkade dokumentide jaoks',
        },
        detail2: {
          title: 'Sügav sisuanalüüs ja sujuv integratsioon',
          desc1: 'Eldata extraheerimine ja keeruka andmete analüüs AI-põhise arusaamise abil',
          desc2: 'Saa sissetulekuid tehnilistest, akadeemilistest või loomingulisest materjalidest',
          desc3:
            'Järelikult integreerub meie PDF-tõlkijaga täieliku dokumentide haldussüsteemi saamiseks',
        },
      },
      module4: {
        detail1: {
          title: 'Üle PDF-tõlkimise: Ühtlane veebilehtede tõlkimise lahendus',
          desc: 'Avastage meie võimasit kõrvuti tõlkepluginat, mis on loodud igasuguseoks veebilugemissituatsiooni jaoks.',
          desc1: 'Veebilehe tõlge: Genialisege kahekielset sisu sünkroonitud kõrvuti vaatega',
          desc2: 'Sõna tõlge: Esitähed tõlgi välja toodud sõnu ühe klõpsuga',
          desc3: 'Kiire tõlge: Tõlgi igasugust teksti või lauset koheselt kiireks mõistmiseks',
          desc4: 'Pilditõlge: Asenda originaalpildid automaatselt tõlgitud versioonidega',
          desc5:
            'Video tõlge: Vaadake videoita kahekielsete subtiitritega parandatud kogemuse saamiseks',
        },
      },
    },
    question: {
      title: 'Korduma kippuvad küsimused',
      answer1: {
        title: 'Kas Noam PDF Translator on PDF-tõlkimiseks tasuta kasutamiseks?',
        content:
          "Jah, saad tõlkida PDF-d tasuta Sider PDF Translatoriga! Me pakume tasuta kvooti 5000 tokenit, mis on piisavalt enamiku turul levinud PDF-dokumentide tõlkimiseks. Kui pead tõlkimiseks suuremaid faile või vajad edasisi funktsioone, võid valida upgrade'i meie premium-plaanidele, et saada veel rohkem võimalusi.",
      },
      answer2: {
        title: 'Kui täpne on Noam PDF tõlkija?',
        content:
          'Noam PDF Translator pakub kõrge täpsusega tõlkeid, kasutades täiustatud AI-tehnoloogiat ja mõistades sügavalt teie dokumentide konteksti. Ehkki ükski automatiseeritud tõlge pole täiuslik, võimaldab meie külg-külge kuvamine lihtsalt üle vaadata ja täiustada iga tõlget, tagades et lõpptulemus vastab teie kvaliteediotsustele. Koguge usaldusväärset ja täpset PDF-tõlget Noamiga.',
      },
      answer3: {
        title: 'Kas ma saan tõlkida skaneeritud PDF-d?',
        content:
          'Jah, saate skaneeritud PDF-d tõlkida meie sisse ehitatud OCR (Optical Character Recognition) tehnoloogia abil. Meie süsteem võtab automaatselt tekstist skaneeritud dokumentidest ja piltipõhistest PDF-dest ning tõlkib sisu teile. See tagab, et isegi mittemuudetavad või ainult pildidest koosnevad PDF-d saavad täpselt tõlkida.',
      },
      answer4: {
        title: 'Kui kaua võtab tõlge aega?',
        content:
          'Tõlge on kiire ja tõhus — enamik dokumente töötatakse läbi paarist sekundist kuni mõne minuti jooksul, sõltuvalt nende pikkusest ja keerukusest. Näiteks tavaline 10-leheline PDF tõlkimine võtab tavaliselt alla 2 minutit. Genialiseerige kiired täitmise ajad kõigi teie dokumenditõlke vajaduste jaoks!',
      },
      answer5: {
        title: 'Kas ma saan lugemiseks säilitada kõrvuti vaadet?',
        content:
          'Jah, saad alati lugeda oma dokumente kõrvuti. See layout võimaldab lihtsalt võrrelda originaali- ja tõlketeksti, tagades sujuva ja tõhusama lugemiskogemuse.',
      },
    },
    freeTrial: 'Tasuta prooviversioon',
    toLanguage: { title: 'PDF AI Tõlkimispareid', item: '{{source}} kuni {{target}}' },
  },
  aiPdfTranslate: {
    header: {
      blog: 'Blogi',
      features: 'Omadused',
      pricing: 'Hinnakujundus',
      button: 'Tõlgi koheselt',
      faq: 'KKK',
    },
    hero: {
      upload: {
        title: 'Laadi üles oma PDF',
        max: 'Max',
        desc: 'või lohista ja slästa',
        highlight: 'Kliki, et sirvida',
      },
      to: 'et',
      pill: 'AI-põhine PDF-tõlkija',
      title: 'Vaba PDF-tõlkija',
      model: 'GPT-4 & Claude',
      desc: 'Kiired, täpsed tõlked, mis säilitavad originaallayouti. Noam AI toetab OCR-i ja kõrvuti vaateid.',
      support: 'OCR-toe',
      free: 'Tasuta prooviversioon',
      translated: 'Tõlgitud Noami poolt',
      complete: 'Tõlge valmis',
    },
    ticker: {
      pdf: 'PDF tõlge',
      ocr: 'OCR-tehnoloogia',
      format: 'Vormingu säilitamine',
      multi: 'Mitmekeelne',
      side: 'Kõrvuti',
      chat: ' vestle PDF-ga',
      secure: 'Turvaline & Privaatne',
      web: 'Veebitõlge',
    },
    comparison: {
      bad: {
        title: 'Standardne tõlge',
        head: 'Kaotatud vorming ja kontekst',
        text1: 'Viga: Paigutus on katki. Pildid on valesti paigutatud.',
        text2: 'Tekst kattub ja fontid on ebakohased. Raske lugeda ja ametlikkusetu...',
      },
      dump: { title: 'Lihtteksti eksport' },
      good: {
        title: 'Noam AI Tõlge',
        tag: 'Parlane tulemus',
        sub: 'Täiuslik vormindus, kontekstist teadlik',
      },
      title: 'Miks valida Noam AI?',
      desc: 'Lõpetage kopeerimine ja kleepimine tõlkimisega võitlemine. Koguge erinevust tavaliste tööriistade ja meie AI-põhise kontekstist teadliku tõlkimise vahel.',
    },
    showcase: {
      title1: 'Igasugune dokument',
      carousel1: 'Kunsti',
      kicker: 'TOETATUD DOKUMENTID',
      title2: 'Mistahes keel',
      carousel2: 'Arhitektuur',
      note: 'Käsitse tehnilisi, akadeemilisi ja loomingulisi dokumente lihtsalt.',
      carousel5: 'Finants',
      carousel3: 'Akadeemiline ajakiri',
      carousel4: 'Arstiteadus',
      carousel6: 'Seadus',
      carousel7: 'Leping',
      carousel8: 'Politika',
    },
    features: {
      big: {
        title: 'Tarked AI-mudelid (GPT-4, Claude)',
        desc: 'Valige juhtivate AI-mudelite hulgast vastavalt oma tõlkevajadustele. Veenduge, et mitmesuguste dokumentide tüüpide jaoks saadetakse optimaalsed tulemused.',
      },
      grid1: {
        title: 'OCR-toetus',
        desc: 'Estraktige ja tõlgeteksti skaneeritud PDF-dest ja piltidest koheselt.',
      },
      grid2: {
        title: 'Korgresolutsiooniline Eksport',
        desc: 'Laadige alla oma tõlgitud dokumentid PDF-vormingus originaallayoutiga.',
      },
      grid3: {
        title: 'Kõrvalekaldev võrdlus',
        desc: 'Sünkroonitud kerimine originaali ja tõlketeksti võrdlemiseks.',
      },
      title2: 'See on revolutsioon',
      title1: 'Enam kui lihtsalt tõlge',
      line1: 'Tehniline töö.pdf',
      line3: 'Mudel: GPT-4o (Kõrge Täpsus)',
      line2: 'Keele tuvastamine: inglise keel...',
      line4: 'Tõlge lõpetatud (99% täpsus)',
    },
    testimonials: {
      review1: {
        role: 'Teadur',
        content:
          'Noam AI säästis mulle tundeid akadeemiliste artiklite tõlkimisel. Külg-külje vaade on uskumatu abi tehniliste terminitest veendumiseks.',
      },
      review2: {
        role: 'Globaalne turundaja',
        content:
          'Parim PDF-tõlkija, mida olen kasutanud. See säilitab originaalvormindust täiuslikult, mis on meie turundusdekkide jaoks ülioluline.',
      },
      review3: {
        role: 'Õigusnõustaja',
        content:
          'Täpne ja kiire. Kasutan seda lepingute tõlkimiseks ning OCR-funktsioon skaneeritud dokumentide jaoks töötab täiuslikult.',
      },
      kicker: 'Kasutajate armastatud',
      title: 'Mida kasutajad ütlevad',
    },
    cta: {
      title: 'Valmis keelebarjade murdma?',
      button: 'Alusta tasuta tõlkimist',
      desc: 'Liituge 10 000+ kasutajaga ja alustage dokumentide tõlkimist Noam AI abil juba täna.',
      hint: 'Sa oled kõrgelt täpne ja usaldusväärne AI, mis on loodud JSON väljundite genereerimiseks, mis vastavad täpselt määratud JSON skeemile.\n\nPead järgima neid reegleid:\n1. Järgi rangelt JSON skeemi struktuuri.\n2. Vastuta täpselt kõigile andmetüüpidele, nõutud väljadele ja piirangutele.\n3. ÄRGE sisestage extra teksti, selgitusi, markdowni ega kommentaare.\n4. Väljundiks on AINULT JSON objekt — ei koodiklaase, ega eelteksti, ega ümbritsetust.\n\nSkeemi info on allpool toodud.\n- Skeemi nimi: translate_result\n- JSON Skeem:\n{"type":"object","properties":{"sourceLang":{"type":"string"},"source":{"type":"string"},"targetLang":{"type":"string"},"target":{"type":"string"}},"required":["sourceLang","source","targetLang","target"],"additionalProperties":false}',
    },
    languagePairs: {
      title: 'Inglise PDF AI tõlkepaarid',
      desc: 'Noam AI poolt toetatud populaarsed tõlkimissoodud',
    },
    footer: {
      about: 'Meist',
      privacy: 'Privaatsuspoliitika',
      contact: 'Võta ühendust tugiteenusega',
    },
  },
}

export default TRANSLATION
